import { ChangeDetectionStrategy, Component, computed, input, model } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { SurveyVariableConditionFilterDirectionEnum } from 'src/app/enums/survey-variable-condition-filter-direction.enum';
import { SurveyFilter } from 'src/app/models/survey.model';

export interface TargetedDepartmentCategoryOption {
  id: number;
  name: string;
}

@Component({
  selector: 'app-targeted-department-categories-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './targeted-department-categories-card.component.html',
  styleUrl: './targeted-department-categories-card.component.css',
  host: { '[attr.title]': 'null' },
  imports: [MatButtonModule, MatFormFieldModule, MatSelectModule],
})
export class TargetedDepartmentCategoriesCardComponent {
  readonly title = input('Categorías de departamento');
  readonly description = input<string | null>(null);
  readonly embedded = input(false);
  readonly error_message = input<string | null>(null);
  readonly options = input.required<TargetedDepartmentCategoryOption[]>();
  readonly selection = model.required<number[]>();

  protected readonly all_selected = computed((): boolean => {
    const options = this.options();

    if (options.length === 0) {
      return false;
    }

    const selected_ids = new Set(this.selection());

    return options.every(option => selected_ids.has(option.id));
  });

  protected readonly none_selected = computed(() => this.selection().length === 0);

  protected onSelectionChange(event: MatSelectChange<number[]>): void {
    this.selection.set(event.value);
  }

  protected selectAll(): void {
    this.selection.set(this.options().map(option => option.id));
  }

  protected deselectAll(): void {
    this.selection.set([]);
  }
}

export function getToAnswerDepartmentCategoryIds(filters: SurveyFilter[]): number[] {
  const filter = filters.find(item => item.direction === SurveyVariableConditionFilterDirectionEnum.ToAnswer);

  return filter?.department_categories?.map(department_category => department_category.id) ?? [];
}

export function setTargetedDepartmentCategorySelection(control: FormControl<number[]>, department_category_ids: number[]): void {
  control.setValue(department_category_ids);
  control.markAsDirty();
  control.markAsTouched();
}
